import * as React from "react"
import { useIntl } from "react-intl"

import { DEFAULT_OPTION_TITLE_FATHER_NODE } from "components/CustomerBehavior/Switching/constants"
import { InformationTitleFatherNode } from "components/CustomerBehavior/Switching/interfaces"
import {
	getTitleSelectFilter,
	optionsFilterToTitleFatherNode,
	titleTreeSwitching,
	validateAndUpdateNodeValues,
} from "components/CustomerBehavior/Switching/utils"

type TreeTitleProps = {
	fatherNodeTitle: InformationTitleFatherNode
}

const TreeTitle: React.FC<TreeTitleProps> = (props) => {
	const { fatherNodeTitle } = props

	const intl = useIntl()

	const titleFilterSelect = fatherNodeTitle?.name
		? getTitleSelectFilter(
				validateAndUpdateNodeValues(
					fatherNodeTitle?.name,
					fatherNodeTitle?.description
				).name
		  )
		: optionsFilterToTitleFatherNode[DEFAULT_OPTION_TITLE_FATHER_NODE].id

	return (
		<div className="title-tree">
			<p>{intl.formatMessage({ id: titleTreeSwitching.id })}</p>
			<span>
				{titleFilterSelect &&
					intl.formatMessage({ id: titleFilterSelect }).toLowerCase()}
			</span>
			<span>
				{`"${
					validateAndUpdateNodeValues(
						fatherNodeTitle?.name,
						fatherNodeTitle?.description
					).description
				}"`}
			</span>
		</div>
	)
}

export default TreeTitle
